import React from "react";

const SiteSelect = ({ client, sites, activeSite, changeSite }) => {
  return (
    <div className="py-2">
      <div className="form-group">
        <label htmlFor="siteSelect" className="font-weight-bold text-muted">
          {client && client.name}
        </label>
        <select
          className="form-select dropdown"
          id="siteSelect"
          value={activeSite ? activeSite : 0}
          onChange={changeSite}
        >
          {sites &&
            sites.map((site) => (
              <option key={site.id} value={site.id}>
                {site.name}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default SiteSelect;
